import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, throwError } from 'rxjs';
import { AuthenticationState } from '../store/authentication/authentication.state';
import { StateClear } from 'ngxs-reset-plugin';
import { inject } from '@angular/core';

/**
 * Interceptor function that adds the `Authorization` header to the request if the user is authenticated.
 * If the request returns an HTTP error with status 401 (Unauthorized), the state will be cleared and the user will be navigated to the login page.
 *
 * @param req - The HTTP request object.
 * @param next - The next HTTP handler function.
 * @returns An Observable of the HTTP response.
 */
export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const store: Store = inject(Store);
  const router: Router = inject(Router);
  const accessToken = store.selectSnapshot(AuthenticationState.accessToken);

  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        store.dispatch(new StateClear());
        router.navigateByUrl('/login');
      }

      return throwError(() => error);
    })
  );
}
